// Generated by ReScript, PLEASE EDIT WITH CARE


var mainContainer = "w-full max-w-md mt-24 mx-auto px-4";

var titleStyle = "text-3xl sm:text-40px text-dark-gray text-center lg:text-left mb-4";

var subtitleStyle = "sm:text-xl text-dark-gray text-center lg:text-left pb-8";

var notificationContainer = "pt-4 clear-both";

var formInput = "appearance-none rounded-lg border-2 w-full text-gray-800 leading-tight py-3 px-3 mb-4 outline-none";

var formLabel = "block text-gray-800 text-xl font-bold my-8 text-left";

var phoneInputStyle = "container mx-auto text-left";

var dropdownStyle = "text-left rounded-lg border-2";

var buttonStyle = "text-left rounded-lg border-2";

var submitBtnStyle = "mx-auto mt-6 w-40 h-12";

var errorTextStyle = "block text-xs text-left mb-2 text-prezzee-red";

export {
  mainContainer ,
  titleStyle ,
  subtitleStyle ,
  notificationContainer ,
  formInput ,
  formLabel ,
  phoneInputStyle ,
  dropdownStyle ,
  buttonStyle ,
  submitBtnStyle ,
  errorTextStyle ,
}
/* No side effect */
